export default {
	// api: "//api-dev.weststeincard.com/api/",
	api: "https://api.weststeincard.com/api/",
	scoringApi: "https://ipqualityscore.com/"
}
